import type { FrMrgaPolicyItem, FrMrgaPolicyItemScope } from '../fr-mrga-insurance.ts'

const CONTRACT = { type: 'contract' } as const

const EVERY_USE = {
  executive: true,
  company: true,
  tow_truck: true,
  two_wheeler: true,
  rental: true,
  trailer: true,
} as const

// A third-party vehicle is insured for its liability alone, so it carries no damage guarantee.
const DAMAGE_FORMULAS = { third_party: false, third_party_plus: true, all_risks: true } as const

export const frMrgaScopeByPolicyItem_v1_0_0 = {
  publicLiability: CONTRACT,
  productsAndCompletedWorksLiability: CONTRACT,
  fire: CONTRACT,
  electricalDamage: CONTRACT,
  climateEvents: CONTRACT,
  naturalDisasters: CONTRACT,
  terrorism: CONTRACT,
  waterDamage: CONTRACT,
  buildingDamageAfterTheft: CONTRACT,
  theft: CONTRACT,
  glass: CONTRACT,
  machineryAndComputerBreakage: CONTRACT,
  businessInterruption: CONTRACT,
  civilLiability: CONTRACT,
  criminalDefenseAndRecourse: CONTRACT,
  driverProtection: CONTRACT,
  ownedVehiclesDamage: { type: 'vehicle', uses: EVERY_USE, formulas: DAMAGE_FORMULAS },
  personalBelongingsAndAccessories: CONTRACT,
  vehiclesForSaleDamage: { type: 'vehiclesForSale' },
  entrustedVehiclesDamage: CONTRACT,
  legalProtection: CONTRACT,
} as const satisfies Record<FrMrgaPolicyItem, FrMrgaPolicyItemScope>
